import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { IsLogged } from 'services/authentication';
import { Icon } from 'ui/styled';
import { ThemedComponent } from 'ui/theme';
import { Content, FormContent, SideBackgroundImageContainer } from './styled';

export default function ContainerUnauthenticated({ children, center }) {
  const history = useHistory();
  const navigate = useCallback((to) => history.push(`/${to}`), [history]);
  const completeNext = useCallback(() => navigate('home'), [navigate]);
  const init = useCallback(async () => {
    const isLogged = await IsLogged();
    if (isLogged) {
      completeNext();
    }
  }, [completeNext]);

  useEffect(() => {
    init();
    window.scrollTo(0, 0);
  }, [init]);

  return (
    <ThemedComponent>
      <Content>
        <Row className="noPadding">
          <Col md={{ size: 6 }} className="noPadding">
            <FormContent center={center}>{children}</FormContent>
          </Col>
          <Col md={{ size: 6 }} className="noPadding">
            <SideBackgroundImageContainer>
              <Icon icon="logo-outside" />
            </SideBackgroundImageContainer>
          </Col>
        </Row>
      </Content>
    </ThemedComponent>
  );
}
